export default __webpack_public_path__ + "assets/228318019cfa195d9a43e9d3c477717f.jpg";